import { useParams, Navigate, useLocation } from 'react-router-dom';

/**
 * ProfileRedirect - Redirects legacy English profile URLs to French URLs
 * Handles: /profile/:id → /profil/:id
 *         /profile/:id/:tab → /profil/:id/:tab (with French tab names)
 *         /profile/:id/:tab/:documentId → /profil/:id/:tab/:documentId
 *         /profile/:id/edit → /profil/:id/edit
 */
export const ProfileRedirect = () => {
  const { profileId, tab, documentId } = useParams<{
    profileId: string;
    tab?: string;
    documentId?: string;
  }>();
  const location = useLocation();

  // Check if this is an edit route
  const isEditRoute = location.pathname.includes('/edit');

  // Translate English tab names to French
  const translateTab = (englishTab?: string): string | undefined => {
    if (!englishTab) return undefined;

    const tabTranslations: Record<string, string> = {
      'overview': 'apercu',
      'subsidies': 'subventions',
      'assistant': 'assistant'
    };

    return tabTranslations[englishTab] || englishTab;
  };

  const frenchTab = translateTab(tab);

  // Build the French URL
  let targetPath = `/profil/${profileId}`;

  if (isEditRoute) {
    targetPath += '/edit';
  } else if (documentId && frenchTab) {
    targetPath += `/${frenchTab}/${documentId}`;
  } else if (frenchTab) {
    targetPath += `/${frenchTab}`;
  } else {
    // PERF FIX: Default to subventions tab to avoid extra redirect cycle
    targetPath += '/subventions';
  }

  return <Navigate to={targetPath} replace />;
};
